export default __webpack_public_path__ + "static/media/ความสำคัญของกิจกรรม-3.bf000ef8.png";